import React, { useContext, useEffect, useState } from "react";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import { SettingContext } from "../../routes";
import { Button, Card, Skeleton } from "antd";
import CustomHeader from "../common/Header";
import { missedCallRateColumns } from "./columns";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomTable from "../common/Table";

const MissedCallRate = () => {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "missed_call_rate",
    });
    const { selectedDates, kioskSelection, selectedHotels } =
        useContext(SettingContext);
    const hotel_ids = selectedHotels;
    const [start_date, end_date] = selectedDates;
    const [formData, setFormData] = useState({
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: missedCallRateStatus,
        data: missedCallRateRes,
        refetch: fetchMissedCallRateCount,
    } = useQuery(
        "missedCallRateTable",
        async () => {
            return await HTTP("/dashboard/getMissedcallsRateDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchMissedCallRateCount();
    }, []);

    useEffect(() => {
        fetchMissedCallRateCount();
    }, [formData]);

    useEffect(() => {
        if (missedCallRateStatus === "success") {
            const { data: missedCallRateData, total } = missedCallRateRes;
            setTotalRecords(total);
            setTableData(missedCallRateData);
        }
    }, [missedCallRateStatus, missedCallRateRes]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }
        const updatedFormData = { ...formData, ...others };
        updatedFormData.all_selected =
            updatedFormData.hotel_ids.length > 0 ? false : true;
        updatedFormData.start_date = formatDate(updatedFormData.start_date);
        updatedFormData.end_date = formatDate(updatedFormData.end_date);
        setFormData(updatedFormData);
    }

    async function downloadReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getMissedcallsRateDetailsReport", {
            ...tempFormData,
        });

        downloadCSV(res, `missed_call_rate_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downloadReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {missedCallRateStatus === "loading" ||
                missedCallRateStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={missedCallRateColumns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                    />
                )}
            </Card>
        </Card>
    );
};

export default MissedCallRate;
